import {ProjectAttachment} from 'types/attachements';
import {ProjectAttachmentTypesEnum} from 'features/studio/projects/constants/project-attachments';

/**
 * Filter a project's attachments down to the visible "HUB" images
 * (the gallery images shown on the public site), sorted by their
 * stored order. Unlike the public ApiProjectResource we do NOT
 * filter by `is_published` here — the admin needs to see every
 * image while reordering, even unpublished drafts.
 */
export const getProjectImages = (
  attachments?: ProjectAttachment[]
): ProjectAttachment[] =>
  (attachments ?? [])
    .filter(a => a.type === ProjectAttachmentTypesEnum.HUB)
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
